export default __webpack_public_path__ + "static/media/Pursuit.26f35e86.svg";